import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface TextareaProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
    placeholder?: string;
    rows?: number;
}
const Textarea: FC<TextareaProps> = ({ value, onChange, col, error, label, placeholder, required, rows, itemClassName, helper }) => {
    const inputClassName = useMemo(() => {
        if (Boolean(error)) {
            return `w-full border px-4 py-2 rounded border-red-500 focus:border-red-500 focus:ring-red-500 focus:outline-none`;
        }
        return "w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500"
    }, [error])
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <textarea
            value={value || ""}
            onChange={e => onChange && onChange(e.currentTarget.value)}
            className={inputClassName}
            placeholder={placeholder}
            rows={rows}
        />
    </Item >
}
export default Textarea;